import {
	comMapping
} from '../../../../util/Function/comMapping.js'
export function getdata() {
	var obj = {
		searchlist: [{
				prop: "yewkmCode",
				label: '业务科目代码',
				type: "input",
			},
			{
				prop: "yewkmName",
				label: '业务科目名称',
				type: "input",
			},
			{
				prop: "declareType",
				label: '申报税种',
				type: "select",
				selectval: comMapping.$declareTypeMapping,
				selectchange:true
			},
			{
				prop: "reportId",
				label: '报表名称',
				type: "select",
				disabled:true
			},
			{
				prop: "enableFlag",
				label: '是否启用',
				type: "select",
				selectval: [{
						label: "禁用",
						value: "0"
					},
					{
						label: "启用",
						value: "1"
					},
				],
			},
			{
				prop: "sourceFlag",
				label: '映射方式',
				type: "select",
				selectval: comMapping.$sourceFlagMapping
			},
			{
				prop: "description",
				label: '说明',
				type: "input"
			},
			{
				prop: "subjectCodes",
				label: '对应公司科目代码',
				type: "input"
			},
			{
				prop: "companySubjectName",
				label: '对应公司科目名称',
				type: "input"
			},
		],
		searchdata: {
			yewkmCode: "",
			yewkmName: "",
			declareType: "",
			reportId: "",
			enableFlag: "",
			sourceFlag: "",
			description: "",
			subjectCodes: "",
			companySubjectName: "",
			ids: "",
		},
		headData: [{
				title: "业务科目代码",
				prop: "yewkmCode",
				width: 160,
				

				issort: true,
			},
			{
				title: "业务科目名称",
				prop: "yewkmName",
				width: 160,
				

				issort: true,
			},
			{
				title: "申报税种",
				prop: "declareType",
				width: "110",
				issort: true,
				custom: true
			},
			{
				title: "报表名称",
				prop: "reportName",
				width: 160,
				

				issort: true,
			},
			{
				title: "是否启用",
				prop: "enableFlag",
				width: "110",
				issort: true,
				custom: true
			},
			{
				title: "映射方式",
				prop: "sourceFlag",
				width: "110",
				issort: true,
				custom: true
			},
			{
				title: "对应公司科目代码",
				prop: "subjectCodes",
				width: 160,
				

				issort: true,
				custom: true
			},
			{
				title: "对应公司科目名称",
				prop: "companySubjectName",
				width: 160,
				
				issort: true,
			},
			{
				title: "说明",
				prop: "description",
				width: 160,
				
				issort: true,
			},
			{
				title: "操作",
				prop: "cz",
				width: 120,
				custom: true,
				fixed: 'right'
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
	}
	return obj
}
